import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ae9b312"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col-12 col-lg-8"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uq-preloader" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loader loader--3" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "col-12 col-lg-8 d-flex align-items-center justify-content-center flex-column mb-32 mb-lg-0"
}
const _hoisted_5 = { class: "h4 title fw-normal text-primary" }
const _hoisted_6 = {
  key: 2,
  class: "col-12 col-lg-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_patient_consultation_view = _resolveComponent("the-patient-consultation-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.status === 'loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!_ctx.currentConsultation && _ctx.status === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('No hay niguna consulta seleccionada.')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentConsultation && _ctx.status === 'loaded')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.currentConsultation && _ctx.canShowConsultation)
            ? (_openBlock(), _createBlock(_component_the_patient_consultation_view, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}